import { render, staticRenderFns } from "./PaymentChannel.vue?vue&type=template&id=da0749e0&scoped=true"
import script from "./PaymentChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentChannel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PaymentChannel.vue?vue&type=style&index=0&id=da0749e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0749e0",
  null
  
)

export default component.exports